import H1 from "modules/ebiForms/definitions/H1";
import H2 from "modules/ebiForms/definitions/H2";
import H3 from "modules/ebiForms/definitions/H3";
import H4 from "modules/ebiForms/definitions/H4";
import H5 from "modules/ebiForms/definitions/H5";
import H6 from "modules/ebiForms/definitions/H6";
import H7 from "modules/ebiForms/definitions/H7";
import H8 from "modules/ebiForms/definitions/H8";
import { IEbiFormDefinition } from "modules/ebiForms/typings";

/** PCPR i powiatowy urząd pracy: H1–H8 (docs/magistrat/ebi-wnioski). */
const FORMS: IEbiFormDefinition[] = [H1, H2, H3, H4, H5, H6, H7, H8];

export default FORMS;
